import { FormProviderFn } from "@life-without-barriers/react-components"
import React from "react"
import { contentTypes as ct } from "@life-without-barriers/gatsby-common"
import {
  AgedCareForm,
  ContactUsForm,
  DisabilityForm,
  QcssContactForm as DisabilityQcssForm,
  FosterCareForm,
  LeaveAGiftForm,
  MSTContactForm,
  YpepContactForm,
  MentalHealthCDPSForm,
  MentalHealthForm,
  RefugeesAndAsylumSeekersForm,
  HippyProgramForParentsAndYoungstersForm,
  AlcoholAndOtherDrugsForm,
  ForcedMarriagesForm
} from "@life-without-barriers/shared-contact-form"

export interface StandardForm {
  formKind: string
  formId: string
}

export interface MSTForm {
  formKind: "mst-training"
  formId: string
  mstEvent: ct.Event
}

const FormProvider: FormProviderFn = (formOptions: StandardForm | MSTForm) => {
  const { formId, formKind } = formOptions
  if (formKind === "mst-training" && (formOptions as MSTForm).mstEvent) {
    return (
      <MSTContactForm
        formId={formId}
        selectedEvent={(formOptions as MSTForm).mstEvent}
      />
    )
  }
  switch (formKind) {
    case "contact-us": {
      return <ContactUsForm formId={formId} />
    }
    case "disability-qcss": {
      return <DisabilityQcssForm formId={formId} />
    }
    case "disability-ypep": {
      return <YpepContactForm />
    }
    case "leave-a-gift-in-your-will": {
      return <LeaveAGiftForm />
    }
    case "disability-home-living":
    case "disability-support-coordination":
    case "disability-bis":
    case "disability": {
      return <DisabilityForm formId={formId} formKind={formKind} />
    }
    case "foster-care": {
      return <FosterCareForm formId={formId} formKind={formKind} />
    }
    case "aged-care": {
      return <AgedCareForm formId={formId} />
    }
    case "alcohol-and-other-drugs": {
      return <AlcoholAndOtherDrugsForm formId={formId} />
    }
    case "mental-health": {
      return <MentalHealthForm formId={formId} />
    }
    case "mental-health-cdps": {
      return <MentalHealthCDPSForm formId={formId} />
    }
    case "refugees": {
      return <RefugeesAndAsylumSeekersForm formId={formId} />
    }
    case "cyf-hippy": {
      return <HippyProgramForParentsAndYoungstersForm formId={formId} />
    }
    case "forced-marriages": {
      return <ForcedMarriagesForm formId={formId} />
    }
    default: {
      throw new Error(
        `FormProvider does not currently support form kind '${formKind}'`
      )
    }
  }
}

export default FormProvider
